import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment/moment';

@Component({
  selector: 'latitude-ui-daterange',
  templateUrl: './daterange.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./daterange.component.scss']
})
export class LatitudeUIDateRangeComponent implements OnInit {

  @ViewChild('dateStart') startDate;
  @ViewChild('dateEnd') endDate;

  @Input() modelStart: any;
  @Input() modelEnd: any;
  @Input() dates: any;

  @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();

  startDateOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
    openSelectorTopOfInput: true,
    editableDateField: false,
    showSelectorArrow: false,
    showClearDateBtn: false,
    showTodayBtn: false,
    openSelectorOnInputClick: true,
    disableSince: {day: 0, month: 0, year: 0}
  };
  endDateOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy',
    openSelectorTopOfInput: true,
    editableDateField: false,
    showSelectorArrow: false,
    showClearDateBtn: false,
    showTodayBtn: false,
    openSelectorOnInputClick: true,
    disableUntil: {day: 0, month: 0, year: 0}
  };

  updateFromParent = false;

  showHourPopup = false;
  hourStart: String;
  minutesStart: String;
  hourEnd: String;
  minutesEnd: String;
  hourStartCopy: String;
  minutesStartCopy: String;
  hourEndCopy: String;
  minutesEndCopy: String;
  hoursErrors = 0;

  constructor() { }

  private buildDateObject(date) {
    let response = {
      day: parseInt(moment(new Date()).format('D'), 10),
      month: parseInt(moment(new Date()).format('M'), 10),
      year: parseInt(moment(new Date()).format('YYYY'), 10),
    };
    if (date && date.format) {
      response = {
        day: parseInt(date.format('D'), 10),
        month: parseInt(date.format('M'), 10),
        year: parseInt(date.format('YYYY'), 10)
      };
    }
    return response;
  }

  ngOnInit() {
    // if (this.dates) {
      setTimeout(() => {
        if (this.modelStart) {
          this.hourStart = this.modelStart.format('HH');
          this.minutesStart = this.modelStart.format('mm');
          this.startDate.selectDate(this.buildDateObject(this.modelStart));
        }
        if (this.modelEnd) {
          this.hourEnd  = this.modelEnd.format('HH');
          this.minutesEnd = this.modelEnd.format('mm');
          this.endDate.selectDate(this.buildDateObject(this.modelEnd));
        }
      }, 1);
    // }
  }

  onDateStartChanged($event) {
    let startDateFormatted = moment($event.formatted, 'DD.MM.YYYY');
    let endDateFormatted = moment(this.endDate.selectionDayTxt, 'DD.MM.YYYY');
    if (startDateFormatted.format() >= endDateFormatted.format()) {
      this.endDate.selectDate(this.buildDateObject(startDateFormatted.add(1, 'days')));
    }
    this.endDateOptions.disableUntil = this.buildDateObject(startDateFormatted);
    this.endDate.setOptions(this.endDateOptions);

    if (!this.updateFromParent && this.startDate.selectionDayTxt !== '00.00.0') {
      startDateFormatted = moment($event.formatted + ` ${this.hourStart}:${this.minutesStart}`, 'DD.MM.YYYY HH:mm');
      endDateFormatted = moment(this.endDate.selectionDayTxt + ` ${this.hourEnd}:${this.minutesEnd}`, 'DD.MM.YYYY HH:mm');
      this.dateChangeEvent(startDateFormatted, endDateFormatted);
    }
  }

  onDateEndChanged($event) {
    let startDateFormatted = moment(this.startDate.selectionDayTxt, 'DD.MM.YYYY');
    let endDateFormatted = moment($event.formatted, 'DD.MM.YYYY');
    if (startDateFormatted.format() >= endDateFormatted.format()) {
      this.startDate.selectDate(this.buildDateObject(endDateFormatted.subtract(1, 'days')));
    }
    this.startDateOptions.disableSince = this.buildDateObject(endDateFormatted.subtract(1, 'days'));
    this.startDate.setOptions(this.startDateOptions);

    if (!this.updateFromParent && this.endDate.selectionDayTxt !== '00.00.0') {
      startDateFormatted = moment(this.startDate.selectionDayTxt + ` ${this.hourStart}:${this.minutesStart}`, 'DD.MM.YYYY HH:mm');
      endDateFormatted = moment($event.formatted + ` ${this.hourEnd}:${this.minutesEnd}`, 'DD.MM.YYYY HH:mm');
      this.dateChangeEvent(startDateFormatted, endDateFormatted);
    }
  }

  updateDates(dates) {
    this.updateFromParent = true;
    this.startDate.selectDate(this.buildDateObject(dates.start));
    this.endDate.selectDate(this.buildDateObject(dates.end));

    setTimeout(() => {
      this.updateFromParent = false;
    }, 500);
  }

  dateChangeEvent(start, end) {
    this.dateChange.emit(<any>{
      start: start,
      end: end,
      from: 'daterange'
    });
  }

  hourPopup() {
    this.hourStartCopy = this.hourStart;
    this.minutesStartCopy = this.minutesStart;
    this.hourEndCopy = this.hourEnd;
    this.minutesEndCopy = this.minutesEnd;
    this.showHourPopup = !this.showHourPopup;
  }

  changeHour() {
    if (this.hoursErrors === 0) {
      this.hourStart = this.hourStartCopy;
      this.minutesStart = this.minutesStartCopy;
      this.hourEnd = this.hourEndCopy;
      this.minutesEnd = this.minutesEndCopy;
      this.showHourPopup = false;

      this.setModelHours();

      const startDateFormatted = moment(this.startDate.selectionDayTxt + ` ${this.hourStart}:${this.minutesStart}`, 'DD.MM.YYYY HH:mm');
      const endDateFormatted = moment(this.endDate.selectionDayTxt + ` ${this.hourEnd}:${this.minutesEnd}`, 'DD.MM.YYYY HH:mm');
      this.dateChangeEvent(startDateFormatted, endDateFormatted);
    }
  }

  resetHours() {
    this.hourStart = this.hourStartCopy = '00';
    this.minutesStart = this.minutesStartCopy = '00';
    this.hourEnd = this.hourEndCopy = '00';
    this.minutesEnd = this.minutesEndCopy = '00';
    this.hoursErrors = 0;
    this.setModelHours();
  }

  setModelHours() {
    this.modelStart.set({hour: this.hourStart, minute: this.minutesStart, second: 0, millisecond: 0});
    this.modelEnd.set({hour: this.hourEnd, minute: this.minutesEnd, second: 0, millisecond: 0});
  }

  _keyPressHour(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  _keyupHour(event: any, max) {
    const value =  parseInt(event.currentTarget.value, 0);

    if (event.currentTarget.className.indexOf('error') >= 0) {
      this.hoursErrors --;
    }
    event.currentTarget.className = event.currentTarget.className.replace('error', '');

    if (value >= max || isNaN(value)) {
      event.currentTarget.className += ' error';
      this.hoursErrors ++;
    }
  }
}



// WEBPACK FOOTER //
// ./src/latitude-ui/timeslider/daterange/daterange.component.ts